import React from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import { getDodDate, getMonthAndYear } from "../../common/DisplayDate";
import getPersonName from "../../common/Name";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";
import { getFormattedPhone } from "../../common/Phone";

const getSilverRelativeDetails = (props, record, relIndex, innerRelIndex) => {
  const relRows = [];
  let header = "";
  if (record !== undefined) {
    header = `${_.get(record, "names[0].name[0].firstName[0]._", "")} ${_.get(
      record,
      "names[0].name[0].middleName[0]._",
      ""
    )} ${_.get(record, "names[0].name[0].lastName[0]._", "")}`;
    const DOB = getMonthAndYear(_.get(record, "DOBs[0].DOB[0]"));

    relRows.push(
      <Table.Row key={`relatives_dob_${relIndex}_${innerRelIndex}`}>
        <Table.Cell width={3}>DOB: {DOB}</Table.Cell>
        <Table.Cell width={5}>
          Age: {_.get(record, "DOBs[0].DOB[0].age[0]._", "")}
        </Table.Cell>
        <Table.Cell width={8} colSpan={2} />
      </Table.Row>
    );

    const baseIdentity = _.get(record, "DODs[0].deceasedRecord[0]");
    let dod;
    if (baseIdentity) {
      dod = _.get(baseIdentity, "DOD[0]");
      if (dod !== undefined) {
        relRows.push(
          <Table.Row key={`relatives_dod_${relIndex}_${innerRelIndex}`}>
            <Table.Cell width={6}>
              Deceased Date:{" "}
              {getDodDate(dod, { userAccount: props.userAccount })}
            </Table.Cell>
            <Table.Cell width={6}>
              Age At Death: {_.get(baseIdentity, "ageAtDeath[0]._", "")}
            </Table.Cell>
            <Table.Cell width={3} colSpan={2} />
          </Table.Row>
        );
      }
    }
    const names = _.get(record, "names[0].name");
    _.forEach(names, (name, index) => {
      if (index > 0) {
        relRows.push(
          <Table.Row key={`identity_row_${relIndex}_${innerRelIndex}_${index}`}>
            <Table.Cell width={10} colSpan={2}>
              AKA:{" "}
              {getPersonName(
                _.get(name, "firstName[0]._", ""),
                _.get(name, "middleName[0]._", ""),
                _.get(name, "lastName[0]._", ""),
                props
              )}
            </Table.Cell>
            <Table.Cell width={6} colSpan={3} />
          </Table.Row>
        );
      }
    });

    const addressInfos = _.get(record, "addresses[0].address");
    _.forEach(addressInfos, (addressdetails, addIndex) => {
      relRows.push(
        <Table.Row
          key={`address_row_${relIndex}_${innerRelIndex}_${addIndex}`}
          className={addIndex % 2 === 1 ? "table-row-odd-child" : ""}
        >
          <Table.Cell width={2}>Address:</Table.Cell>
          <Table.Cell width={8}>
            <Address
              addressNode={addressdetails}
              noBreakIconsAndText
              {...props}
            />
          </Table.Cell>

          <Table.Cell width={3}>Dates of occupancy:</Table.Cell>
          <Table.Cell width={3}>
            {_.get(addressdetails, "firstDate[0].year[0]._", "")} -
            {_.get(addressdetails, "lastDate[0].year[0]._", "")}
          </Table.Cell>
        </Table.Row>
      );
      const phones = _.get(addressdetails, "phonesAtAddress[0].phone");
      const phoneNumbers = [];
      _.forEach(phones, (phone) => {
        const phoneNumber = _.get(phone, "phoneNumber[0]._", "");
        if (phoneNumber !== "")
          phoneNumbers.push(getFormattedPhone(phoneNumber));
      });

      if (phoneNumbers.length > 0) {
        relRows.push(
          <Table.Row
            width={3}
            key={`contact_row_${relIndex}_${innerRelIndex}_${addIndex}`}
            className={addIndex % 2 === 1 ? "table-row-odd-child" : ""}
          >
            <Table.Cell width={2}>Contact: </Table.Cell>
            <Table.Cell width={8} />
            <Table.Cell width={3}>Phones:</Table.Cell>
            <Table.Cell width={3}>
              {phoneNumbers.map((p, i) => (
                <p
                  className="margin-bottom-0"
                  key={`rel_phone_${i}_${relIndex}_${innerRelIndex}_${addIndex}`}
                >
                  {p}
                </p>
              ))}
            </Table.Cell>
          </Table.Row>
        );
      }
    });
    const innerRecords = _.get(record, "relatives[0].relative");
    const innerRows = [];
    if (innerRecords !== undefined && innerRecords.length > 0) {
      _.forEach(innerRecords, (innerRecord, inRelIndex) => {
        innerRows.push(
          <Table.Row
            key={`relatives_inner_body_${relIndex}_${innerRelIndex}_${inRelIndex}`}
          >
            <Table.Cell colSpan={4}>
              {getSilverRelativeDetails(
                props,
                innerRecord,
                relIndex,
                inRelIndex
              )}
            </Table.Cell>
          </Table.Row>
        );
      });
      if (innerRows.length > 0) {
        relRows.push(
          <Table.Row
            key={`relatives_inner_header_${relIndex}_${innerRelIndex}`}
          >
            <Table.Cell colSpan={4}>
              <SimpleAccordionContent
                {...this.props}
                name={`Relatives of ${header}`}
                rows={innerRows}
              />
            </Table.Cell>
          </Table.Row>
        );
      }
    }
  }
  return (
    <SimpleAccordionContent
      key={`relative_table_${relIndex}_${innerRelIndex}`}
      {...this.props}
      name={header}
      rows={relRows}
    />
  );
};

export default getSilverRelativeDetails;



// WEBPACK FOOTER //
// ./src/components/reports/Silver/SilverRelativeDetails.js